import { ChevronDownIcon } from "@chakra-ui/icons";
import { Button, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { useIntlContext } from "context/TranslationContext";
import { useEffect, useState } from "react";
import { languagesItems } from "./utils";
import "./LanguageSelect.css";

const LanguageSelect = () => {
  const { locale, setLocale } = useIntlContext();
  const [selectedLanguage, setSelectedLanguage] = useState(locale);

  useEffect(() => {
    setSelectedLanguage(locale);
  }, [locale]);

  useEffect(() => {
    setLocale(selectedLanguage);
    //eslint-disable-next-line
    localStorage.setItem("language", selectedLanguage);
  }, [selectedLanguage, setLocale]);

  return (
    <div className="language-select">
      <Menu>
        <MenuButton as={Button} rightIcon={<ChevronDownIcon />}>
          {languagesItems
            .filter((item) => item.lang === selectedLanguage)
            .map((e, index) => (
              <img key={index} width={20} src={e.flag} alt={e.lang} />
            ))}
        </MenuButton>
        <MenuList>
          {languagesItems.map((item, index) => (
            <MenuItem
              className="language-select-item"
              key={index}
              onClick={() => {
                setSelectedLanguage(item.lang);
              }}
            >
              <img width={30} height={30} src={item.flag} alt={item.lang} />
              {item.text}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </div>
  );
};

export default LanguageSelect;
